import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { AUTO_INSIGHTS_DRAWER, AUTO_INSIGHTS_SETTINGS } from '@src/utils/sensor/track';
import { track } from '@utils';
import { CDN_ACCOUNT_TYPE } from '@utils/constants';
import {
  aiAlertsP5FeatureSelector,
  aiBrokenAssetsSelector,
  accountTypeSelector,
  aiNewappVersionSelector,
} from '@store/common/selectors';
import { StyledDrawer, StyledCollapse, ComingSoonText, StyledTag } from './styled';
import AlertInsights from './AlertInsights';
import BrokenAssets from './BrokenAssets';
import NewAppVersion from './NewAppVersion';
import { SectionExtra } from './Common';
import SettingsDrawer, { SettingTypes } from './Settings';
import useDrawerState from './Hooks/useDrawerState';
import Header from './Header';

import { Collapse } from 'antd';

const { Panel } = Collapse;

function AutoInsightsDrawer() {
  const [visible, setVisible] = useState(false);
  const settingsDrawer = useDrawerState({ trackKey: AUTO_INSIGHTS_SETTINGS });

  const onClose = () => {
    setVisible(false);
  };

  useEffect(() => {
    document.addEventListener('auto-insights-drawer', ({ detail }: any) => {
      const { visible } = detail;
      setVisible(visible);
      if (visible) {
        track({ event: AUTO_INSIGHTS_DRAWER });
      }
    });
  }, []);

  const aiAlertsP5 = useSelector(aiAlertsP5FeatureSelector);
  const aiBrokenAssets = useSelector(aiBrokenAssetsSelector);
  const customerAccountType = useSelector(accountTypeSelector);
  const aiNewappVersion = useSelector(aiNewappVersionSelector);

  return (
    <div>
      <StyledDrawer
        title={<Header openSettings={settingsDrawer.openDrawer} />}
        placement="right"
        closable
        onClose={onClose}
        open={visible}
        key="auto-insights-drawer"
        mask
        width={400}
      >
        <StyledCollapse
          bordered={false}
          defaultActiveKey={[
            SettingTypes.alertInsights,
            SettingTypes.brokenAssests,
            SettingTypes.appVersionPerf,
          ]}
        >
          {customerAccountType !== CDN_ACCOUNT_TYPE && aiNewappVersion ? (
            <Panel
              header={<div>{'New App Version'}</div>}
              key={SettingTypes.appVersionPerf}
              extra={<SectionExtra text="" />}
            >
              {aiNewappVersion ? (
                <NewAppVersion />
              ) : (
                <ComingSoonText>
                  {
                    'This Product is not included in your company’s product packaging. Contact your Conviva representative for more information.'
                  }
                </ComingSoonText>
              )}
            </Panel>
          ) : (
            // This is a temporary message will be removed while going live
            <Panel
              header={<div>{'New App Version'}</div>}
              key={SettingTypes.lowCohorts}
              extra={<StyledTag color="cyan">Coming Soon</StyledTag>}
            >
              <ComingSoonText>
                {
                  'Automatic detection of app upgrades and performance comparison to previous stable version.'
                }
              </ComingSoonText>
            </Panel>
          )}
          {customerAccountType !== CDN_ACCOUNT_TYPE ? (
            <Panel
              header={<div>{'Broken Assets'}</div>}
              key={SettingTypes.brokenAssests}
              extra={<SectionExtra text="" />}
            >
              {aiBrokenAssets ? (
                <BrokenAssets />
              ) : (
                <ComingSoonText>
                  {
                    'This Product is not included in your company’s product packaging. Contact your Conviva representative for more information.'
                  }
                </ComingSoonText>
              )}
            </Panel>
          ) : (
            ''
          )}
          <Panel
            header={<div>{'AI Alert Insights'}</div>}
            key={SettingTypes.alertInsights}
            extra={<SectionExtra text="" />}
          >
            {aiAlertsP5 ? (
              <AlertInsights />
            ) : (
              <ComingSoonText>
                {' '}
                AI alerts should be enabled to view alert insights. Please contact Conviva support.{' '}
              </ComingSoonText>
            )}
          </Panel>
          <SettingsDrawer
            visible={settingsDrawer.visible}
            closeSettings={settingsDrawer.closeDrawer}
          />
        </StyledCollapse>
      </StyledDrawer>
    </div>
  );
}

export default AutoInsightsDrawer;
